<template>
  <div>
    <div id="subheader"> </div>
    <div id="main-container">
      <div id="label-container">
        <span id="label">Empresas</span>
      </div>
      <div id= "container">
        <div id="list-header-container">
          <input id="busqueda" type="text" placeholder="Busqueda de clientes por nombre o código" v-model="filter">
        </div>
        <div id="list-container" style="margin-top: 40dp">
          <table v-if="filtered.length" cellspacing="20">
            <tr v-for="(item, key) of filtered" :key="key">
              <td><input type="radio" :id="`empresa-${item.Id}`" v-model="empresa" :value="item"></td>
              <td>
                <label :for="`empresa-${item.Id}`">{{ item.EmpresaNombre }}</label>
              </td>
            </tr>
          </table>
          <div v-else>
            No se encontraron resultados...
          </div>
        </div>
      </div>
      <div style="text-align: center;margin-top: 30px;">
        <button id="btnok" @click="next">CONTINUAR</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import helper from '@helpers/helper.js';


export default {

  data () {
    return {
      filter: null,
      empresa: null,
      empresas: [],
    }
  },

  computed: {

    filtered () {
      if (!this.empresas.length) {
        return []
      }
      if (this.filter) {
        return this.empresas.filter(c => (c.EmpresaNombre.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1))
      }
      return this.empresas
    }

  },


  mounted () {
    this.empresas = this.$store.state.user.empresas    
  },

  methods: {

    next () 
    {
      if (this.empresa) 
      {
        helper.getEmpresa(this.$store.state.user.responseLogin,this.empresa,this.configCallback)
      }
    },

    exit () 
    {
      this.$router.push({ name: "login" });
    },


  configCallback(){
     this.getDatosCliente();
   },



//   getImages(){
//     var idImagen = this.$store.state.user.usuario.ArchivoLogoId 
//     if ((idImagen != null) && (idImagen != 0))
//     {
//       if (this.$store.state.user.imagenLogo == '')
//       {
//         let config = {
//               method: 'GET',
//               responseType: 'blob',
//               url:'/WebSalesArchivo?ArchivoId='+idImagen+'&Ancho=150',
//               headers: {
//                           Token:        this.$store.state.user.usuario.Token,
//                           ClientSecret: this.$store.state.entorno.clientSecret,
//                           EmpresaId:    this.$store.state.entorno.idEmpresa
//                        }
//             }
//             axios
//             .request(config)
//             .then(response => {
//               let reader = new FileReader()
//               reader.onload = () => {
//                   this.imagenProducto = reader.result
//                   this.$store.commit('user/saveImagenLogo',this.imagenProducto)
//               }
//               console.log(response.data)
//               reader.readAsDataURL(response.data)
//             })
//             .catch(err => {
//               this.imagenProducto = '/dist/logo_header2.png'
//               this.$store.commit('user/saveImagenLogo',this.imagenProducto)
//             })
//       }
//       else
//       {
//         this.imagenProducto = this.$store.state.user.imagenLogo
//       }
//     }
//     else
//     {
//       this.imagenProducto = '/dist/logo_header2.png'
//     }

//   },

  getDatosCliente() {
      axios
        .get("/WebSalesCliente?ClienteId=" + this.$store.state.user.usuario.ClienteId, {
          headers: {
              Token:        this.$store.state.user.usuario.Token,
              ClientSecret: this.$store.state.entorno.clientSecret,
              EmpresaId:    this.$store.state.entorno.idEmpresa
          }
        })
        .then(
          response => {
            if (response.data.Code == 0) 
            {
              this.$access('user');
              this.$store.commit("user/saveCliente", response.data);
              this.$router.push({ name: "home" });
            } 
            else
            {
              this.$store.commit("loader/stop");
              alert(response.data.Message);
              this.$store.commit('user/deleteUser');
              this.$store.commit('user/deleteCliente');
              this.$store.commit('user/deleteEmpresas');
              this.$store.commit('user/deleteResponseLogin');
              this.$store.commit('user/deleteImagenLogo'); 
            }
          },
          error => {
            this.$store.commit("loader/stop");
            console.log(error);
          }
        );
    },

  }
}
</script>

<style scoped>


#btnok {
  width: 100px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none;
  background: #44C7F4;
  border-radius: 20px;
  color: #ffffff;
  outline: none;
}

#btncancel {
  width: 120px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none;
  color: #4969B2;
  background: #ffffff;
  border-radius: 20px;
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}


 #subheader {
    width: 100%;
    height: 35vh;
    background: linear-gradient(#005A9F , #1899D6);
    }


   #main-container{
    position: absolute;
    top: 55vh;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 700px;
    height: 85vh;
    }


   #label-container{
     width: 700px;
     height: 10vh;
    }

   #label{
     color:#ffffff;
     font-size: 27px;
    }


   #container{
     width: 700px;
     height: 65vh;
     border-width: 1px;
     border: 1px solid #dddddd;
     box-sizing: border-box;
     background-color: #ffffff;
    }

   #list-header-container{
     height: 13vh;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     background-color: #ffffff;
    }

   #busqueda{
    border-radius: 20px;
    width: 400px;
    margin-top:15px;
    padding-left: 40px;
    height:30px;
    border-style: solid;
    border:none;
    border-width: 1px;
    border: 1px solid #dddddd;
    color: #000000;
    outline: none;
    background: white url(/dist/icon-search.png) left no-repeat ;
    background-size: 25px 25px;
    background-position: 10px;
   }

   #seleccion-container{
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    }

   .seleccion{
    color:#2292CD;
    font-weight: normal;
    margin-left:0 auto;
    margin-right: 0 auto;
    margin-top: 0px;
    font-size: 11px;
    font-weight: 500;
    text-align: center;
    }


   .seleccion:hover{
       cursor: pointer;
     }


   #separador{
    margin-left: 15px;
    margin-right: 15px;
    font-weight: 500;
    font-size: 13px;
    color:#dddddd;
    }


   #list-container{
    width: 630px;
    height: 49vh;
    margin-top:0px;
    margin-left: 25px;
    margin-right: 25px;
    overflow: auto;
    background-color: #ffffff;
    }

/*background-color: #55ffff;*/

   #btnContainer{
     width: 660px;
     height: 10vh;
     display: flex;
     flex-direction:row;
     justify-content: flex-end;
     align-items: center;
    }


   #btnAgregarPromo{
     width: 120px;
     height: 30px;
     font-size: 9px;
     margin-left: 5px;
     margin-right: 5px;
     border-style: solid;
     border:none;
     color: #4969B2;
     background: #ffffff;
     border-radius: 20px;
     border-width: 1px;
     border: 1px solid #4969B2;
     outline: none;
   }


   #btnCarrito{
     width: 100px;
     height: 30px;
     margin-left: 5px;
     margin-right: 5px;
     font-size: 9px;
     border-style: solid;
     border:none;
     background: #44C7F4;
     border-radius: 20px;
     color: #ffffff;
     outline: none;
   }

   #btnok:hover{cursor: pointer;}
   #btncancel:hover{cursor: pointer;}

   .fade-enter-active, .fade-leave-active {
     transition-property: opacity;
     transition-duration: .25s;
   }

   .fade-enter-active {
     transition-delay: .25s;
   }

   .fade-enter, .fade-leave-active {
     opacity: 0}





   .fadePro-enter {
     opacity: 0;
   }
   .fadePro-enter-active {
     transition: opacity 0.5s;
   }
   .fadePro-enter-to {
     opacity: 1;
   }
   .fadePro-leave {
     opacity: 1;
   }
   .fadePro-leave-active {
     transition: opacity 0.1s;
   }
   .fadePro-leave-to {
     opacity: 0;
   }

   /*-----------------------------------------------------------------------------------------------------------------------*/

   /* width */
   ::-webkit-scrollbar {
       width: 5px;
   }

   /* Track */
   ::-webkit-scrollbar-track {
       box-shadow: inset 0 0 5px #dddddd;
       border-radius: 10px;
   }

   /* Handle */
   ::-webkit-scrollbar-thumb {
       background: #cccccc;
       border-radius: 10px;
   }

   /* Handle on hover */
   ::-webkit-scrollbar-thumb:hover {
       background: #bbbbbb;
   }



   ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
       color: #dddddd;
       opacity: 1; /* Firefox */
   }

   :-ms-input-placeholder { /* Internet Explorer 10-11 */
       color: #dddddd;
   }

   ::-ms-input-placeholder { /* Microsoft Edge */
       color: #dddddd;
   }
</style>



// WEBPACK FOOTER //
// src/components/views/preselect/empresas.vue